import {dashboardGeneticsUploadUniqueStateId} from './dashboard-genetics-upload.models';

export class UploadGeneticFile {
  static readonly type = `${dashboardGeneticsUploadUniqueStateId} ${UploadGeneticFile.name}`;

  constructor(public genFile: File, public patientUid = '') {}
}

export class UploadGeneticFileSuccess {
  static readonly type = `${dashboardGeneticsUploadUniqueStateId} ${UploadGeneticFileSuccess.name}`;
}

export class UploadGeneticFileFail {
  static readonly type = `${dashboardGeneticsUploadUniqueStateId} ${UploadGeneticFileFail.name}`;

  constructor(public error: any) {}
}

export class ClearUploadGeneticProgress {
  static readonly type = `${dashboardGeneticsUploadUniqueStateId} ${ClearUploadGeneticProgress.name}`;
}
